import React from "react";

const ProfileCard = ({ icon, value, title, bg }) => {
  return (
    <div className="flex items-center gap-3 bg-white p-4 font-['Inter'] shadow-[0_-1px_4px_0_#00000040] sm:gap-4 sm:p-5 2xl:gap-6 2xl:p-6">
      <div
        className={`flex h-11 w-11 shrink-0 items-center justify-center sm:h-12 sm:w-12 2xl:h-[60px] 2xl:w-[60px] ${bg}`}
      >
        {icon}
      </div>

      <div className="min-w-0">
        <h3 className="text-xl font-semibold leading-6 text-[#1D2026] sm:text-[22px] 2xl:text-2xl">
          {value}
        </h3>

        <p className="text-sm font-medium leading-[22px] tracking-[-1%] text-[#4E5566] sm:text-base 2xl:text-lg">
          {title}
        </p>
      </div>
    </div>
  );
};

export default ProfileCard;
